import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function RawMaterialImports({ rawMaterialImports = [] }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const allMetrics = [
    { key: "import_volume_shipments", label: "Import Volume (Shipments)" },
    { key: "time_period", label: "Time Period" },
    {
      key: "benchmark_pricing_usd_per_mt",
      label: "Benchmark Pricing (USD/MT)",
    },
    { key: "key_suppliers", label: "Key Suppliers" },
    { key: "import_dependence_pct", label: "Import Dependence (%)" },
    { key: "avg_lead_time_days", label: "Avg. Lead Time (Days)" },
    { key: "strategic_risk_assessment", label: "Strategic Risk Assessment" },
  ];

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(rawMaterialImports);
    setTabData(transformed);
    setTableBelowDescription(
      <ParsedTextWithLinks
        text={rawMaterialImports?.[0]?.response?.tableComments || ""}
      />
    );
  }, [rawMaterialImports]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Raw Material Imports"
      subtitle=""
      data={tabData}
      metrics={allMetrics}
      rowIdentifier="material_name"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default RawMaterialImports;
